<template lang="html">
  <div id="footer">
		<div class="container med-container">
			<div class="row">
				<div class="col-12 col-lg-4 col-logo">
					<router-link class="btn-logo" to="/">
						<img src="public/images/logo.png">
					</router-link>

          <p class="mt-2">
            <router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>
          </p>
          <p>
            <router-link to="/politicas-de-contratacion">Políticas de contratación</router-link>
          </p>
				</div>

        <div class="col-md-6 col-lg-4 col-addresss">
          <h6>Dirección</h6>
          <p>
            503 Interamerica BlvdLaredo, TX 78045, USA
          </p>
        </div>

				<div class="col-md-6 col-lg-4 col-copy">
          <div class="box-networks">
            <span>Síguenos en:</span>
            <a class="t-150" target="_blank" href="https://www.facebook.com/marquezexpressinc/"><i class="fa-brands fa-facebook-f"></i></a>
            <a class="t-150" target="_blank" href="https://www.instagram.com/marquezexpress/"><i class="fa-brands fa-instagram"></i></a>
          </div>
					<p>
						© 2025 Marquez Express. Todos los derechos reservados.
					</p>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
}
</script>
